import type { FC } from 'react'
import React from 'react'
import { Switch } from 'react-router-dom'

import AppLayout from './AppLayout'
import SectionRoute from './SectionRoute'
import {
  Home,
  Dashboard,
  Developments,
  Reviews,
  Login,
  Development,
  Awards,
  Companies,
  UserProfile,
  CompanyUsers,
  EditCompanyUser,
  CreateCompanyUser,
  Widgets,
  CreateWidget,
  Media,
  Guides,
  Resources,
  ResetPassword,
  OutreachHome,
  OutreachCreate,
} from '../pages'
import { NAVIGATION } from '../constants/navigation'

const Routes: FC = () => {
  return (
    <AppLayout>
      <Switch>
        <SectionRoute
          exact
          path={NAVIGATION.home.slug}
          component={Home}
          protectedRoute
        />
        <SectionRoute path={NAVIGATION.login.slug} component={Login} />
        <SectionRoute
          path={NAVIGATION.resetPassword.slug}
          component={ResetPassword}
        />
        <SectionRoute
          exact
          path={NAVIGATION.dashboard.slug}
          component={Dashboard}
          protectedRoute
        />
        <SectionRoute
          exact
          path={NAVIGATION.developments.slug}
          component={Developments}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.development.slug}
          component={Development}
          protectedRoute
        />
        <SectionRoute
          exact
          path={NAVIGATION.awards.slug}
          component={Awards}
          protectedRoute
        />
        <SectionRoute
          exact
          path={NAVIGATION.companies.slug}
          component={Companies}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.reviews.slug}
          component={Reviews}
          protectedRoute
        />
        <SectionRoute
          exact
          path={NAVIGATION.widgets.slug}
          component={Widgets}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.createWidget.slug}
          component={CreateWidget}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.previewWidget.slug}
          component={CreateWidget}
          protectedRoute
          exact
        />
        <SectionRoute
          path={NAVIGATION.yourProfile.slug}
          component={UserProfile}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.media.slug}
          component={Media}
          protectedRoute
        />
        {/* <SectionRoute
          path={NAVIGATION.brandMedia.slug}
          component={Media}
          protectedRoute
        /> */}
        <SectionRoute
          path={NAVIGATION.guides.slug}
          component={Guides}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.resources.slug}
          component={Resources}
          protectedRoute
        />
        {/* <SectionRoute
            path={NAVIGATION.faq.slug}
            component={Faq}
            protectedRoute
          />
          <SectionRoute
            path={NAVIGATION.singleFaq.slug}
            component={SingleFaq}
            protectedRoute
            exact
          /> */}
        <SectionRoute
          exact
          path={NAVIGATION.users.slug}
          component={CompanyUsers}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.editUser.slug}
          component={EditCompanyUser}
          protectedRoute
          exact
        />
        <SectionRoute
          path={NAVIGATION.editUserPermissions.slug}
          component={CreateCompanyUser}
          protectedRoute
          exact
        />
        <SectionRoute
          path={NAVIGATION.createUser.slug}
          component={CreateCompanyUser}
          protectedRoute
        />
        <SectionRoute
          path={NAVIGATION.outreachHome.slug}
          component={OutreachHome}
          protectedRoute
          exact
          strict
        />
        <SectionRoute
          path={NAVIGATION.outreachCreate.slug}
          component={OutreachCreate}
          protectedRoute
          exact
          strict
        />
      </Switch>
    </AppLayout>
  )
}

export default Routes
